'use client'

import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from '@/components/ui/card'
import { useRouter } from 'next/navigation'
import { ServiceDetail } from '../types/interfaces'

const ServiceCard = ({ detail }: { detail: ServiceDetail }) => {
  const router = useRouter()

  const handleNavigate = () => {
    router.push(`/servizi/${detail.slug}`)
  }

  return (
    <Card className="h-full flex flex-col items-start">
      <CardHeader>{detail.category}</CardHeader>
      <CardContent>
        <CardTitle className="text-2xl">
          <a
            onClick={handleNavigate}
            className="text-green-900 no-underline hover:text-green-700 cursor-pointer"
          >
            {detail.title}
          </a>
        </CardTitle>
        <CardDescription className="text-lg">{detail.short_description}</CardDescription>
      </CardContent>
      <CardFooter className="flex justify-between items-center">
        <a
          href={detail.url}
          target="_blank"
          rel="noopener noreferrer"
          className="text-green-900 no-underline"
        >
          APRI IL LINK
        </a>
      </CardFooter>
    </Card>
  )
}

export { ServiceCard }
